<template>
  <div class="mt_3 content_box">
    <title-box text="实景案例"></title-box>
    <el-carousel :interval="4000" type="card" height="300px" class="mt_3">
      <el-carousel-item v-for="(item, index) in carouselList" :key="index">
        <div
          :style="{ background: 'url(' + item + ') no-repeat center top' }"
          class="h_100"
        ></div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import TitleBox from "@/components/title.vue";
export default {
  name: "RealCase",
  components: {
    TitleBox
  },
  props: ["carouselList"],
  data() {
    return {
      data: []
    };
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.el-carousel__item div {
  width: 100%;
  background-size: cover;
}
</style>
